import React, { useReducer } from 'react';

export enum ActionType {
  DISABLE,
  ENABLE,
  TOGGLE,
}

type ProductStyleActionType = ActionType | undefined;

export type ProductStyleState = {
  aaoOpen: boolean;
  styleSelectOpen: boolean;
  styleSelectMoreOpen: boolean;
};

const defaultState: ProductStyleState = {
  aaoOpen: false,
  styleSelectOpen: false,
  styleSelectMoreOpen: false,
};

export type ProductStyleAction = {
  [Property in keyof ProductStyleState]?: ProductStyleActionType;
};

function applyAction(state: boolean, action: ProductStyleActionType): boolean {
  switch (action) {
    case ActionType.DISABLE:
      return false;
    case ActionType.ENABLE:
      return true;
    case ActionType.TOGGLE:
      return !state;
    default:
      return state;
  }
}

const reducer = (
  state: ProductStyleState,
  action: ProductStyleAction
): ProductStyleState => {
  const {
    aaoOpen: aaoOpenAction,
    styleSelectOpen: styleSelectAction,
    styleSelectMoreOpen: styleSelectMoreOpenAction,
  } = action;

  return {
    aaoOpen: applyAction(state.aaoOpen, aaoOpenAction),
    styleSelectOpen: applyAction(state.styleSelectOpen, styleSelectAction),
    styleSelectMoreOpen: applyAction(
      state.styleSelectMoreOpen,
      styleSelectMoreOpenAction
    ),
  };
};

export const useProductStyleSwitcherState = (
  initialState = defaultState
): [ProductStyleState, React.Dispatch<ProductStyleAction>] => {
  return useReducer(reducer, { ...defaultState, ...initialState });
};

export const openModalRequested = (
  dispatch: React.Dispatch<ProductStyleAction>,
  productGACode: string
): void => {
  dispatch({
    styleSelectOpen: ActionType.ENABLE,
    aaoOpen: ActionType.DISABLE,
    styleSelectMoreOpen: ActionType.DISABLE,
  });
};

export const modalCloseRequested = (
  dispatch: React.Dispatch<ProductStyleAction>
): void => {
  dispatch({
    styleSelectOpen: ActionType.DISABLE,
    aaoOpen: ActionType.DISABLE,
  });
};

export const showMoreRequested = (
  dispatch: React.Dispatch<ProductStyleAction>
): void => {
  dispatch({ styleSelectMoreOpen: ActionType.ENABLE });
};

export const showAAORequested = (
  dispatch: React.Dispatch<ProductStyleAction>
): void => {
  // TODO: Google Analytics
  // logEvent({
  //   analytics: analyticsPayload.quickProductSelectorModalAAOClick(
  //     currentProduct.gaCode
  //   ),
  // });
  dispatch({ aaoOpen: ActionType.ENABLE, styleSelectOpen: ActionType.DISABLE });
};

export const AAOCloseRequested = (
  dispatch: React.Dispatch<ProductStyleAction>
): void =>
  dispatch({
    aaoOpen: ActionType.DISABLE,
    styleSelectOpen: ActionType.DISABLE,
  });
